import React from "react";

function ListOfBlogs() {
  return (
    <div className="ab-br">Coming soon, for now, please check my work.</div>
  );
}

export default ListOfBlogs;
